import { styled } from '@mui/system'
import { TTheme } from '@/core/theme'
import Typography from '@/ui/components/typography'

export const Header = styled('div')<{ theme?: TTheme }>`
    padding: 16px;
    font-size: var(--font-size-l);
    font-weight: 600;
    color: ${({ theme }) => theme?.colors.greys[800]};
`

export const Container = styled('div')<{ theme?: TTheme }>`
    border-radius: 12px;
    height: fit-content;

    .alerts-over-time-card {
        height: 325px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`

export const ChartTitle = styled(Typography)<{ theme?: TTheme }>`
    margin-bottom: 16px;
    color: ${({ theme }) => theme?.colors.greys[800]};
`

export const ChartContainer = styled('div')<{ theme?: TTheme }>`
    background: ${({ theme }) => theme?.colors.greys[50]};
    padding: 24px;
    border-radius: 4px;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
`
